import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import Button from "@builder/components/general/Button";
import { useAppDispatch } from "@builder/store/store";
import { closePopup } from "@builder/store/slices/popupSlice";
import { userLogout } from "jwt-storage-lib";

const LogoutPopup = () => {
    const dispatch = useAppDispatch();

    const handleLogout = () => {
        const logout = async () => {
            await userLogout();
            window.location.href = import.meta.env.VITE_HUB_REDIRECT;
        };

        logout();
    };

    return (
        <div className="logout-popup">
            <OliverText text="Confirm logout" size="l" weight="semi-bold" />
            <OliverText size="s" text="Are you sure you would like to logout out? Any unsaved build data will be lost." />
            <div className="button-row">
                <Button buttonStyle="secondary" text="Cancel" onClick={() => dispatch(closePopup())} />
                <Button buttonStyle="primary" text="Confirm" onClick={handleLogout} />
            </div>
        </div>
    );
};

export default LogoutPopup;
